import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { useAnalytics } from 'use-analytics';
import { useMemo } from 'react';
import _ from 'lodash';
import Header from '../../../Header';
import Navbar from '../../../Header/Navbar';
import Footer from '../../../Footer';
import PostCard from '../PostCard';

const HomeCustomerPage = () => {
  const { track } = useAnalytics();
  const { travelAgency } = useSelector((state) => state.user);
  const doShowHomePageToScreenHeight = travelAgency && travelAgency.siteTheme
  && travelAgency.siteTheme.showHomePageToScreenHeight;
  const homePageBackgroundImageOverlayColorRgb = travelAgency && travelAgency.siteTheme
  && travelAgency.siteTheme.homeBgImgOverlayRGBA ? travelAgency.siteTheme.homeBgImgOverlayRGBA : '7, 28, 37, 0.66';
  const pageHeadingClass = (travelAgency && travelAgency.siteTheme
  && travelAgency.siteTheme.pageHeadingClass) || 'text-center text-white';
  const doHaveSearchFormBgColor = travelAgency && travelAgency.siteTheme
  && travelAgency.siteTheme.doHaveSearchFormBgColor;
  const doShowPosts = travelAgency && travelAgency.posts && travelAgency.posts.length > 0;
  const postsInBgImage = useMemo(() => (travelAgency && travelAgency.posts
    && travelAgency.posts.length > 0 ? _.filter(travelAgency.posts, (p) => p.doShowInBgImage) : []),
  [travelAgency]);
  const postsNotInBgImage = useMemo(() => (travelAgency && travelAgency.posts
    && travelAgency.posts.length > 0
    ? _.filter(travelAgency.posts, (p) => !p.doShowInBgImage) : []),
  [travelAgency]);

  const customHomePageAgencyLogo = travelAgency && travelAgency.settings
    && travelAgency.settings.customHomePageAgencyLogo;

  const doHideHomeCustomerFooter = travelAgency?.settings?.doHideHomeCustomerFooter;

  const handleClickPostImage = (URL) => {
    track('Home_redirectToAdsUrl', { URL });
  };

  return (
    <div className="bg-home-footer-0 min-h-screen flex flex-col relative">
      <div className={clsx('relative', { 'md:h-screen': doShowHomePageToScreenHeight })} style={{ background: `url('${travelAgency.bgImage || 'https://travelwitsimages.s3.amazonaws.com/site+images/tw-home-page.png'}') center / cover no-repeat` }}>
        <div style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          backgroundColor: `rgba(${homePageBackgroundImageOverlayColorRgb})`,
        }}
        />
        <div className={clsx('relative pb-24', { 'lg:pb-8': doShowPosts, 'lg:pb-40': !doShowPosts })}>
          <div className="bg-home-navbar-0">
            <div className="container mx-auto px-2 sm:px-0 text-home-header-0">
              <Navbar agencyLogoOverride={customHomePageAgencyLogo} />
            </div>
          </div>
          <div className={clsx('container mx-auto font-tagline w-full text-2xl sm:text-3xl', pageHeadingClass, {
            'mt-20 sm:mt-32': doShowHomePageToScreenHeight && !doShowPosts,
            'mt-32': !doShowHomePageToScreenHeight && !doShowPosts,
            'sm:mt-8 mt-32': doShowPosts,
          })}
          >
            {travelAgency.pageHeading ? (
              <div className="inline-block" dangerouslySetInnerHTML={{ __html: travelAgency.pageHeading }} />
            ) : <></>}
          </div>
          <div className="mt-10">
            <Header
              doShowNavbar={false}
              doHaveSearchFormBgColor={doHaveSearchFormBgColor}
              textColorClass="text-home-header-0"
              bgColorClass=""
              filterBgColor="bg-home-filter"
              tabTextColorClass="text-home-tabsText-0"
            />
          </div>
        </div>
        {postsInBgImage.length > 0 ? (
          <div className="relative z-10 flex flex-wrap justify-center container mx-auto py-4">
            {postsInBgImage.map((travelAgencyPost) => (
              <PostCard
                key={`${travelAgencyPost.image}-${travelAgencyPost.content}`}
                post={travelAgencyPost}
                onClickPostImage={handleClickPostImage}
              />
            ))}
          </div>
        ) : <></>}
      </div>
      {postsNotInBgImage.length > 0 ? (
        <div className="bg-gray-300 py-4">
          <div className="flex flex-wrap justify-center container mx-auto">
            {postsNotInBgImage.map((travelAgencyPost) => (
              <PostCard
                key={`${travelAgencyPost.image}-${travelAgencyPost.content}`}
                post={travelAgencyPost}
                onClickPostImage={handleClickPostImage}
              />
            ))}
          </div>
        </div>
      ) : <></>}
      <Footer doShowFooter={!doHideHomeCustomerFooter} bgColorClass="bg-home-footer-0" textColorClass="text-home-footer-0" />
    </div>
  );
};

export default HomeCustomerPage;
